<template>
	<div class="home">
		<div class="top-white-box"></div>

		<div class="banners-container" v-if="settings.siteName == 'mommydeals' && false">
			<div class="banner-cards-title">New Features</div>
			<div class="banner-cards">
				<router-link to="/outlet" class="banner-card banner-card-pink">
					<div class="banner-card-title">MommyDeals Outlet</div>
					<div class="banner-card-icon">
						<span class="material-symbols-outlined">shopping_cart</span>
					</div>
				</router-link>
				<router-link to="/advanced-amazon-search" class="banner-card banner-card-yellow">
					<div class="banner-card-title">MommyDeals Amazon Search</div>
					<div class="banner-card-icon">
						<span class="material-symbols-outlined">search</span>
					</div>
				</router-link>
			</div>
		</div>

		<div class="black-friday-banner" v-if="settings.homepageBanner && settings.purimMode">
			<img :src="`/Assets/img/purim.jpg`" />
		</div>
		<div class="black-friday-banner" v-else-if="settings.homepageBanner && settings.siteName != 'mommydeals'">
			<img :src="settings.homepageBanner" />
		</div>

		<div class="top-gray-box" v-else>
			<h1>Latest Deals</h1>
		</div>

		<!--<GiveawayBox />-->
		<Deals :showJoinUs="true" :showPrice="true" />
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import Deals from '@/components/Deals.vue';
	//import GiveawayBox from '@/components/GiveawayBox.vue'
	import settings, { SettingsClass } from '@/settings';

	export default defineComponent({
		name: 'home',
		components: {
			Deals,
			//GiveawayBox
		},
		setup() {
			// No need for data() since we're not using any local state
			// The settings computed property is now just a constant since it's imported directly

			return {
				settings,
			};
		},
	});
</script>

<style scoped>
	.banners-container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 10px;
		color: #fff;
		background-color: #ffd1d4;
        
	}

    .banner-cards-title {
        font-size: 1.5em;
        font-weight: bold;
        font-family: Rubik, Roboto, Avenir, Helvetica, Arial, sans-serif;
        color: #4a4953;
    }

    .banner-cards {
        display: flex;
		flex-direction: row;
		gap: 10px;
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
    }

	.banner-card {
		position: relative;
		width: 100%;
		height: 120px;
		border-radius: 12px;
		overflow: hidden;
		display: grid;
		grid-template-rows: 1fr 1fr;
	}

	.banner-card-pink {
		background: linear-gradient(135deg, #f39bb0, #f4708a);
	}

	.banner-card-yellow {
		background: linear-gradient(135deg, #f6a853, #f18b1e);
	}

	/* quarter circle accent in bottom-right */
	.banner-card::after {
		content: '';
		position: absolute;
		bottom: 0;
		right: 0;
		width: 150px; /* adjust to change curve size */
		height: 150px;
		background: rgba(255, 255, 255, 0.15);
		border-radius: 50% 0 0 0;
		transform: translate(50%, 50%);
	}

	.banner-card-title, a .banner-card-title {
        color: #fff;
		font-size: 1.5em;
		font-weight: bold;
		margin-top: 10px;
		font-family: Rubik, Roboto, Avenir, Helvetica, Arial, sans-serif;
	}

	.banner-card-icon {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		color: #4a4953;
	}

	.banner-card-icon .material-symbols-outlined {
		font-size: 2em;
	}
</style>
